<template lang="html">
  <div>
    
    <md-layout class="whiteframe" style="min-height:200px; padding:40px" v-if="pedidoReady">
      <md-layout md-flex="100" style="font-size:18px; margin: -25px 0 15px 10px;" class="totales">
        Pedido #{{pedido.pedido.FOLIO}}
      </md-layout>
      <md-layout md-flex="100" style="margin-bottom:40px; margin-left:10px" md-hide-small>
        <!-- <md-layout md-flex></md-layout> -->
        <md-layout md-flex="25">
          <div class="timeline-line">Pedido</div>
        </md-layout>
        <md-layout md-flex="25">
          <div :class="pedido.seguimiento.status.trim() === 'Pedido' || pedido.seguimiento.status.trim() === 'Pagado'
            || pedido.seguimiento.status.trim() === 'Enviado' || pedido.seguimiento.status.trim() === 'Entregado' 
            ? 'timeline_status_ball_selected' : 'timeline_status_ball'">
            <md-tooltip md-align="top">
            </md-tooltip>
          </div>
          <div class="timeline-line">Pagado</div>
        </md-layout>
        <md-layout md-flex="25">
          <div :class="pedido.seguimiento.status.trim() === 'Pagado'
            || pedido.seguimiento.status.trim() === 'Enviado' || pedido.seguimiento.status.trim() === 'Entregado' 
            ? 'timeline_status_ball_selected' : 'timeline_status_ball'">
            <md-tooltip md-align="top">
            </md-tooltip>
          </div>
          <div class="timeline-line">Enviado</div>
        </md-layout>
        <md-layout md-flex="20">
          <div :class="pedido.seguimiento.status.trim() === 'Enviado' || pedido.seguimiento.status.trim() === 'Entregado' 
            ? 'timeline_status_ball_selected' : 'timeline_status_ball'">
            <md-tooltip md-align="top">
            </md-tooltip>
          </div>
          <div class="timeline-line">Entregado</div>
        </md-layout>
        <md-layout md-flex="5">
          <div :class="pedido.seguimiento.status.trim() === 'Entregado' 
            ? 'timeline_status_ball_selected' : 'timeline_status_ball'">
            <md-tooltip md-align="top">
            </md-tooltip>
          </div>
        </md-layout>
        <!-- <md-layout md-flex></md-layout> -->
      </md-layout>
      <md-layout style="" md-flex="100" md-hide-medium-and-up>
        <md-layout md-flex="100" style="margin-bottom: 10px;">
          <div class="" style="margin-left:30px;font-weight: bold;color: #acb7c0;">Pedido</div>
          <div :class="pedido.seguimiento.status.trim() === 'Pedido' || pedido.seguimiento.status.trim() === 'Pagado'
            || pedido.seguimiento.status.trim() === 'Enviado' || pedido.seguimiento.status.trim() === 'Entregado' 
            ? 'timeline_status_ball_selected' : 'timeline_status_ball'">
            <md-tooltip md-align="top">
            </md-tooltip>
          </div>
        </md-layout>
        <md-layout md-flex="100" style="margin-bottom: 10px;">
          <div class="" style="margin-left:30px;font-weight: bold;color: #acb7c0;">Pagado</div>
          <div :class="pedido.seguimiento.status.trim() === 'Pagado'
            || pedido.seguimiento.status.trim() === 'Enviado' || pedido.seguimiento.status.trim() === 'Entregado' 
            ? 'timeline_status_ball_selected' : 'timeline_status_ball'">
            <md-tooltip md-align="top">
            </md-tooltip>
          </div>
        </md-layout>
        <md-layout md-flex="100" style="margin-bottom: 10px;">
          <div class="" style="margin-left:30px;font-weight: bold;color: #acb7c0;">Enviado</div>
          <div :class="pedido.seguimiento.status.trim() === 'Enviado' || pedido.seguimiento.status.trim() === 'Entregado' 
            ? 'timeline_status_ball_selected' : 'timeline_status_ball'">
            <md-tooltip md-align="top">
            </md-tooltip>
          </div>
        </md-layout>
        <md-layout md-flex="100" style="margin-bottom: 10px;">
          <div class="" style="margin-left:30px;font-weight: bold;color: #acb7c0;">Entregado</div>
          <div :class="pedido.seguimiento.status.trim() === 'Entregado' 
            ? 'timeline_status_ball_selected' : 'timeline_status_ball'">
            <md-tooltip md-align="top">
            </md-tooltip>
          </div>
        </md-layout>
        
      </md-layout>

      <md-layout md-gutter="16" md-flex="100" style="margin-bottom:30px" class="border">
        <md-layout 
          md-flex-small="100"
          md-flex-xsmall="100">
          <div v-if="pedido.direccion">
            <b>Direccion de envio:</b> <br/>
            {{pedido.direccion.Recibe}} <br/>
            {{pedido.direccion.direccion}}, {{pedido.direccion.NumExt}}( {{pedido.direccion.NumInt}})<br/>
            {{pedido.direccion.Colonia}}, {{pedido.direccion.CP}} <br/>
            {{pedido.direccion.Poblacion}}, {{pedido.direccion.EntFed}}, {{pedido.direccion.Pais}}<br/>
            {{pedido.direccion.telefono}} <br/>
            <div class="totales" style="text-align:start;padding-left:0">N° guia: {{pedido.seguimiento.guia}}</div>
          </div>
          <div v-else style="margin-top: auto; margin-bottom: auto; font-size:16px; padding:0; " class="totales">
            El pedido lo podras recoger en tienda.
          </div>
        </md-layout>
        <md-layout style="max-width:250px"
          md-flex-small="100"
          md-flex-xsmall="100">
          <div style="width:100%; margin-top:10px">
            <b>Resumen del pedido:</b><br/><br/>
            <md-layout md-flex="100" style="padding">
              <md-layout md-align="start" md-flex="50">
                <div class="totales">
                  SubTotal: <br/>
                  IVA: <br/>
                  Total:

                </div>
              </md-layout>
              <md-layout md-align="end" md-flex="50">
                <div class="totales align-end">
                  {{toMoney(parseFloat(pedido.pedido.subtotal))}} <br/>
                  {{toMoney(parseFloat(pedido.pedido.iva))}} <br/>
                  {{toMoney(parseFloat(pedido.pedido.TOTAL))}}
                </div>
              </md-layout>
              <md-layout md-align="end" md-flex="100">
                <md-button class="md-accent" @click.native="getLinkMP"
                v-if="pedido.seguimiento.status.trim() === 'Pedido' && parametros.pago !== 'xCobrar'">Pagar Pedido</md-button>
              </md-layout>
            </md-layout>
          </div>
        </md-layout>
      </md-layout>

      <md-layout md-gutter="16" md-flex="100" style="margin-bottom:30px" class="border" v-if="pedido.seguimiento.Observacion">
        <div>
        <b>Observación:</b><br/> {{pedido.seguimiento.Observacion}}
        </div>
      </md-layout>

      <md-layout md-gutter="16" md-flex="100" style="" class="border">
        <md-layout md-flex="100" v-for="detalle in pedido.detalles" class="border-bottom">
          <md-layout style="margin-right:20px" 
              md-flex-xlarge="15"
              md-flex-large="15"
              md-flex-medium="15"
              md-flex-small="100"
              md-flex-xsmall="100">
            <img class="cartImage" :id="`img${index}`" 
            v-if="detalle.foto && detalle.foto.replace(/ /g,'') !== '' && detalle.foto.replace(/ /g,'') !== null"
            :src="`${parametros.ruta_imagen}${detalle.foto}`" />
            <img class="cartImage" id="" v-else src="../../assets/img/SuperticketElefanteC.png" alt="No se encontro la imagen" />
          </md-layout>

          <md-layout class="md-list-text-container"
            md-flex-xlarge="65"
            md-flex-large="65"
            md-flex-medium="65"
            md-flex-small="100"
            md-flex-xsmall="100">
            <span>{{detalle.descripcion}}</span>
            <div>
              <div class="cartDetails"> Precio: {{toMoney(parseFloat(detalle.precio))}}</div>
              <div class="cartDetails"> Cantidad: {{Math.round(detalle.cantidad)}}</div>
            </div>
          </md-layout>

          <md-layout class="cartTotal"
            md-flex-xlarge="15"
            md-flex-large="15"
            md-flex-medium="15"
            md-flex-small="100"
            md-flex-xsmall="100"
            md-align="end">
            {{toMoney(parseFloat(detalle.precioneto) * detalle.cantidad)}}
          </md-layout>
        </md-layout>
      </md-layout>
      <md-layout md-flex="100" md-align="end" v-if="pedido.seguimiento.status !== 'Entregado'">
        <md-button class="md-accent md-raised" id="Recibido"
        @click.native="confirmarRecibido">Confirmar Recibido</md-button>
      </md-layout>
      <!-- <md-layout md-flex="100" md-align="end">
        <md-button class="md-accent md-raised" id="Recibido" @click.native="sendEmail">enviar</md-button>
      </md-layout> -->
    </md-layout>
  </div>
</template>
<script src="https://smtpjs.com/v3/smtp.js">
</script>
<script type="text/javascript">
import { toMoney } from '../../common/functions/helpers';
import mdCustomTable from '../../shared-components/table/table'
import mdPagination from '../../shared-components/pagination/pagination'
import Email from '../../common/functions/smtp'

export default {
  name: 'Pedidos',
  data() {
    return {
      resourcePedido: this.$api.pedido(this.$resource),
      resourceCliente: this.$api.cliente(this.$resource),
      resourceMP: this.$api.mp(this.$resource),
      pedido: {},
      cliente: {},
      cart: [],
      idPedido: '',
      pedidoReady: false,
      email:"<html ><head></head><body><div style='margin-left:auto; margin-right: auto; width:650px;'><table style='width:650px; font-size:22px'><tr><td style='margin-left:auto; margin-right:auto; text-align:center'><b>Gracias por comprar con nosotros</b></td></tr></table><table style='width:650px'><tr><td style='margin-left:auto; margin-right:auto'><b>Tu Pedido:</b></td></tr></table><br><table style='border:1px solid #acb7c0; border-radius: 10px; width:650px; '><tr><td style='text-align: left; padding: 10px'><b>Dirección de envio:</b><br>Tassia Andrea Chilomer Hinojosa <br>Rio Cihuatlan 1164<br>Las Aguilas<br>Zapopan, Jalisco, Mexico<br></td><td style='text-align:right; padding: 10px'><table style='font-weight: bold; color: #585858; margin-left: auto'><tr><td colsan='2'><b>Resumen del pedido:</b><br><br></td></tr><tr><td style='width:100px'>SubTotal:</td><td>$6,255.65</td></tr><tr><td>IVA:</td><td> $1,000.90</td></tr><tr><td>Total</td><td>$7,256.55</td></tr></table></td></tr></table><br><br><table style='border:1px solid #acb7c0; border-radius: 10px; width:650px'><tr style='border-bottom:1px solid #acb7c0'><td style='width: 110px; padding: 10px'><img style='max-height: 90px;' src='https://stshop.club:85/Ejemplo2/imagen/A_PLAY.JPG' alt='No se encontro la imagen' /></td><td style='text-align: left; padding: 10px'><label style='font-size: 18px'>Play Station Bundle 1TB</label><br>Precio: $5,999.00 <br>Cantidad: 1</td><td style='text-align: right; padding: 10px'><label style='font-size: 18px'>$6958.54</label><br></td></tr></table><br><br></div></body></html>"
    };
  },
  computed: {
  },
  components: {
    mdCustomTable,
    mdPagination
  },
  methods: {
    selectPedido () {
    },
    getLinkMP(){
        const data = {
          nombre: this.cliente.cliente.nombre,
          email: this.cliente.email,
          descripcion: "Pago pedido" + this.pedido.FOLIO
        }
        this.resourceMP.postCargo({ idPedido: this.idPedido }, data)
          .then((response) => {
            window.open(response.data.initpoint,"_self");
          })
          .catch((err) => {

          })
    },
    sendEmail() {
      Email.send({
        Host : "mail.superticket.mx",
        Port : 465,
        Username : "stshop@superticket.mx",
        Password : "CompartShop9515",
        To : 'chilomer@hotmail.com',
        From : "diegochilomer@gmail.com",
        Subject : "Pedido STSHOP",
        Body : this.email
      }).then(
        message => alert(message)
      );
    },
    confirmarRecibido() {
      const seguimiento = this.pedido.seguimiento
      seguimiento.status = 'Entregado'
      const idSeguimiento = seguimiento.idinterno;
      const resourcePedido = this.$api.pedido(this.$resource);
      resourcePedido.putSeguimiento({ idSeguimiento }, seguimiento)
          .then((response) => {
            this.pedido.seguimiento.status = 'Entregado';
          })
          .catch((err) => {
            this.$error(this, err);
          });
    },
    getPedido () {
      const idPedido = this.idPedido;
      const resourcePedido = this.$api.pedido(this.$resource);
      resourcePedido.getPedido({ idPedido })
          .then((response) => {
            this.pedido = response.data;
            this.pedidoReady = true;
          })
          .catch((err) => {
            this.$error(this, err);
          });
    },
    articuloPrecio(precio) {
      if (precio) {
        return toMoney(parseFloat(precio, 10)); 
      }
      return 0.00;
    },
    toMoney,
    goToCatalogo() {
      this.$router.push({ name: 'inicio' });
    },
    goConfirmacion() {
      this.$router.push({ name: 'confirmacion', params: { idPedido: this.idPedido } });
    },
  },
  mounted() {
    this.cart = window.cart;
    this.idPedido = this.$route.params.idPedido;
    this.cliente = localStorage.getItem('cliente') ? JSON.parse(localStorage.getItem('cliente')) : null;
    this.getPedido();
    this.parametros = localStorage.getItem('parametros') ? JSON.parse(localStorage.getItem('parametros')) : {};  
  },
};
</script>
<style src="./pedidosForm.scss" lang="scss"></style>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/spa/pedidosForm/PedidosForm.vue